/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAboutCreator_item = {
    readonly creatorContent: {
        readonly name: string | null;
        readonly description: string | null;
        readonly role: string | null;
    } | null;
    readonly " $refType": "PdpSharedDescriptionAboutCreator_item";
};
export type PdpSharedDescriptionAboutCreator_item$data = PdpSharedDescriptionAboutCreator_item;
export type PdpSharedDescriptionAboutCreator_item$key = {
    readonly " $data"?: PdpSharedDescriptionAboutCreator_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAboutCreator_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDescriptionAboutCreator_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "creatorContent",
      "storageKey": null,
      "args": null,
      "concreteType": "BrowseContentModule",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "description",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "role",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '80b135fbbdcde8f2c76aa0cb5c91776b';
export default node;
